export enum ReimbursementMethod {
  Payroll = 0,
  Check = 1,
  Cash = 2,
  Other = 3,
}
